export enum DeliveryMomentKind {
    Unknown = 0,
    WhenOrderComplete = 1,
    DirectPartialDelivery = 2
}
